import React from 'react';
import '../style/ProgressBar.css';
import Coin from "../../../../assets/svg/Coin";


const ProgressBar = ({
    current = 0,
    total = 100,
    height = '16px',
    backgroundColor = '#372e5c',
    progressColor = '#fff8f8',
    textColor = '#fff8f8',
    progressTextColor = '#372e5c',
    borderRadius = '18.57px',
    showText = true,
    textSize = '8px',
    customText = null
}) => {
    const percentage = Math.min((current / total) * 100, 100);
    const displayText = customText || `${current > total ? total : current}/${total}`;

    return (
        <div
            className="custom-progressbar-container"
            style={{
                height,
                backgroundColor,
                borderRadius
            }}
        >
            <div
                className="custom-progress-fill"
                style={{
                    width: `${percentage}%`,
                    backgroundColor: progressColor,
                    borderRadius
                }}
            ></div>

            {showText && (
                <div className="custom-progress-text-wrapper">
                    <span
                        className="custom-progress-text-bg"
                        style={{
                              display : 'flex',
                            alignItems : 'center',
                                    gap : 3,
                            justifyContent : 'center',
                            color: textColor,
                            fontSize: textSize
                        }}
                    >
                        {displayText}
                        <Coin width={textSize} height={textSize}/>
                    </span>
                    <div
                        className="custom-progress-text-fg"
                        style={{
                            width: `${percentage}%`,
                            fontSize: textSize
                        }}
                    >
                        <span style={{
                            display : 'flex',
                            alignItems : 'center',
                                        justifyContent : 'center',
                                        gap : 3,
                            color: progressTextColor,
                            position: 'relative',
                            left: `${percentage > 0 ? (50 / percentage) * 100 - 50 : 0}%`
                        }}>
                            {displayText}
                                   <Coin width={textSize} height={textSize}/>
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProgressBar;